import React, { useState, useEffect } from "react";
import Sidebar from "../../Components/Sidebar/sidebar";
import Country from "../Country/country";
import Dashboard from "../Dashboard/dashboard";
import Department from "../Department/department";
import Employee from "../Employee/employee";
import Performance from "../Performance/performance";
import Region from "../Region/region";
import "./body.css";
import { MdMenu } from "react-icons/md";
import "react-datepicker/dist/react-datepicker.css";
import Loader from "../../Components/Loading/Loading";
import Treatedappraisal from "../Treatedappraisal/Treatedappraisal";
import Addemployee from "../../Components/Addemployee/addemployee";
import Addepartment from "../../Components/Addepartment/addepartment";
import AddCountry from "../../Components/Addcountry/addcountry";
import Role from "../Role/role";
import AddRole from "../../Components/Addrole/addrole";
import { useCookies } from "react-cookie";
import axios from "axios";
import Addkpi from "../../Components/AddKPI/addkpi";
import Notice from "../../Components/Forwardnotice/Notice";
import ForwardNotice from "../../Components/Notice/forwardnotice";
import KPI from "../KPI/kpi";
import AddRegion from "../../Components/Addregion/addregion";
import UpcomingEvent from "../events/events";
import Createvent from "../../Components/Createvent/createevent";
import Attendance from "../Attendancemanager/attendance";
import Leave from "../Leavemanager/leave";
import Task from "../Taskmanager/task";
import Newtask from "../../Components/Task/newtask";
import Completion from "../../Components/Confirmation/confirmation";
// import Listfunction from '../ListFunction/listfunction'
// import DepartmentsFilter from '../ListFunction/listfunction'
import Error from "../../Components/Error";
import Websitedashboard from "../Websitemanagement/Dashboard/Dashboard";
import Aboutus from "../Websitemanagement/Aboutus/aboutus";
import Executive from "../Websitemanagement/Executives/executive";
import Blog from "../Websitemanagement/Blog/blog";
import Contract from "../Websitemanagement/Contract/Contract";
import MoreCaseDetails from "../Websitemanagement/Contract/Viewcontract";
import { useSelector } from "react-redux";
import { API, API_Local } from "../../server";
import { Store } from "../../Redux/store";
import { getOneUser, getUser } from "../../Redux/Actions/dataResponse";
import { useLocation } from "react-router-dom";

// const today = new Date();
const Body = () => {
  const { buttonaction } = useSelector((state) => state.buttonstatus);

  const [useremail, setUseremail] = useState("");
  const location = useLocation();

  // Destructure the state object
  const { status, email } = location.state || {};

  useEffect(() => {
    // You can use the status and email as needed here
    if (status && email) {
      setUseremail(email);
      console.log("Email: ", email);
      console.log("Status: ", status);

      // Perform any necessary operations with status and email
    }
  }, [status, email]);

  const currentab = useSelector((state) => state.sidebartabs.sidebartabtext);

  const [params, setParams] = useState();
  const [notice, setNotice] = useState("");
  const [menuclick, setMenuclick] = useState(false);
  const [loading, setLoading] = useState({
    status: 0,
    message: "",
    icon: 0,
  });

  const [cookies] = useCookies(["Token"]);
  // const [expiration, setExpiration] = useState(false)
  const [fetching, setFetching] = useState(false);
  const [completed, setCompleted] = useState(false);
  const [arraysList, setArraysList] = useState();
  const [user, setUser] = useState({
    fname: " ",
    lname: " ",
    role: " ",
    designation: " ",
  });

  // const [user, setUser] = useState({
  //     fname: 'Obaloluwa',
  //     lname: 'Oduyemi',
  //     role: 'STAFF',
  //     designation: 'SOFTWARE ENGINEER'
  // })

  useEffect(() => {
    // setParams({role: 'admin', name: 200,})
    Makerolecall();
    FetchUser();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const Makerolecall = async () => {
    setFetching(true);
    try {
      var config = {
        method: "GET",
        url: `${API}/home`,
        headers: {
          Authorization: "Bearer " + cookies.Token,
        },
      };

      await axios(config).then((response) => {
        console.log(response.data.data);
        if (response.data.success === false) {
          setArraysList(response.data.data);
          Store.dispatch(getOneUser(response.data.data));

          setUser({
            fname: response.data.data.user.first_name,
            lname: response.data.data.user.last_name,
            role: response.data.data.user.role,
            designation: response.data.data.user.designation,
          });
          setFetching(false);
        }
      });
    } catch (e) {
      // If response returns status of 401. then the session has expired, user have to re-login Session Time set to 1hr
      if (e.message.includes("401")) {
        // console.log(`Error `)
      }
    }
  };

  const FetchUser = async () => {
    setFetching(true);
    try {
      var config = {
        method: "GET",
        url: `${API_Local}/fetchuser/by-email/?email=${encodeURIComponent(
          useremail
        )}`,
      };

      console.log(config);

      await axios(config).then((response) => {
        // console.log(response.data.data);
        if (response.data.status === 200) {
          Store.dispatch(getUser(response.data.data));
          setFetching(false);
        }
      });
    } catch (e) {
      console.log("Error: ", e.response.data.message);
    }
  };

  useEffect(() => {
    // 👇️ scroll to top on page load
    window.scrollTo({ top: 0, left: 0, behavior: "smooth" });
  }, []);

  const handleClicks = () => {
    setMenuclick(!menuclick);
  };

  const handleNotice = () => {
    setNotice("notice");
  };

  const handleForward = () => {
    setNotice("forwardnotice");
  };

  const handleNoticeCmd = (incoming) => {
    if (incoming.action === "close") {
      setNotice("close");
    } else if (incoming.action === "load") {
      setLoading({
        status: 1,
        message: incoming.text,
        icon: 1,
      });
    } else if (incoming.action === "notload") {
      setLoading({
        status: 2,
        message: incoming.text,
        icon: 2,
      });
    } else if (incoming.action === "success") {
      setLoading({
        status: 2,
        message: incoming.text,
        icon: 1,
      });
    } else {
      setLoading({
        status: 0,
        message: incoming.text,
        icon: 1,
      });
    }
  };

  const handleAddOverlay = (incoming) => {
    setNotice(incoming.tag);
    setParams(incoming);
  };

  const handleCloseoverlay = () => {
    setLoading(0);
  };

  return (
    <div className="body-main-contariner">
      {notice === "forwardnotice" ? (
        <ForwardNotice sendnotice={handleNoticeCmd} />
      ) : notice === "notice" ? (
        <Notice
          sendnotice={handleNoticeCmd}
          shouldload={(incoming) => setLoading(incoming)}
          completedmodal={() => setCompleted(true)}
        />
      ) : notice === "newemployee" ? (
        <Addemployee
          params={params}
          sendnotice={handleNoticeCmd}
          empselect={arraysList}
        />
      ) : notice === "newdepartment" ? (
        <Addepartment
          params={params}
          sendnotice={handleNoticeCmd}
          empselect={arraysList}
        />
      ) : notice === "newcountry" ? (
        <AddCountry
          params={params}
          sendnotice={handleNoticeCmd}
          empselect={arraysList}
        />
      ) : notice === "newregion" ? (
        <AddRegion
          params={params}
          sendnotice={handleNoticeCmd}
          empselect={arraysList}
        />
      ) : notice === "newrole" ? (
        <AddRole
          params={params}
          sendnotice={handleNoticeCmd}
          empselect={arraysList}
        />
      ) : notice === "newkpi" ? (
        <Addkpi
          params={params}
          sendnotice={handleNoticeCmd}
          empselect={arraysList}
        />
      ) : notice === "event" ? (
        <Createvent
          params={params}
          sendnotice={handleNoticeCmd}
          empselect={arraysList}
        />
      ) : notice === "task" ? (
        <Newtask
          params={params}
          sendnotice={handleNoticeCmd}
          empselect={arraysList}
        />
      ) : (
        <></>
      )}

      {buttonaction.status === 1 ? (
        <Loader type="spin" color="red" text={buttonaction.message} />
      ) : buttonaction.status === 2 ? (
        <Error
          closeOverlay={handleCloseoverlay}
          message={buttonaction.message}
          icon={buttonaction.icon}
          isTimeout={false}
        />
      ) : (
        <></>
      )}
      {fetching && <Loader type="bars" color="red" text="Fetching Data" />}
      {completed && <Completion closeoverlay={() => setCompleted(false)} />}
      <Sidebar urole={user} menus={menuclick} />
      <div className="body-contariner">
        <div className="navbar--container">
          <MdMenu className="sidebar-iconss" onClick={handleClicks} />
        </div>
        {currentab === "dashboard" ? (
          <Dashboard
            urole={user}
            forwardnotice={handleForward}
            createnotice={handleNotice}
            page={currentab}
            empselect={arraysList}
          />
        ) : currentab === "employee" ? (
          <Employee
            page={currentab}
            addnewoverlay={handleAddOverlay}
            empselect={arraysList}
          />
        ) : currentab === "department" ? (
          <Department
            sendnotice={handleNoticeCmd}
            page={currentab}
            addnewoverlay={handleAddOverlay}
            empselect={arraysList}
          />
        ) : currentab === "region" ? (
          <Region
            page={currentab}
            addnewoverlay={handleAddOverlay}
            empselect={arraysList}
          />
        ) : currentab === "role" ? (
          <Role
            page={currentab}
            addnewoverlay={handleAddOverlay}
            empselect={arraysList}
          />
        ) : currentab === "country" ? (
          <Country
            page={currentab}
            addnewoverlay={handleAddOverlay}
            empselect={arraysList}
          />
        ) : currentab === "kpi" ? (
          <KPI page={currentab} addnewoverlay={handleAddOverlay} />
        ) : currentab === "events" ? (
          <UpcomingEvent
            urole={user}
            page={currentab}
            addnewoverlay={handleAddOverlay}
          />
        ) : currentab === "treatedapp" ? (
          <Treatedappraisal urole={user} page={currentab} />
        ) : currentab === "task" ? (
          <Task
            urole={user}
            page={currentab}
            addnewoverlay={handleAddOverlay}
          />
        ) : currentab === "leave" ? (
          <Leave
            urole={user}
            page={currentab}
            addnewoverlay={handleAddOverlay}
          />
        ) : currentab === "time" ? (
          <Attendance
            urole={user}
            page={currentab}
            addnewoverlay={handleAddOverlay}
          />
        ) : currentab === "website" ? (
          <Websitedashboard
            urole={user}
            page={currentab}
            addnewoverlay={handleAddOverlay}
          />
        ) : currentab === "aboutus" ? (
          <Aboutus sendnotice={handleNoticeCmd} />
        ) : currentab === "executive" ? (
          <Executive sendnotice={handleNoticeCmd} empselect={arraysList} />
        ) : currentab === "blog" ? (
          <Blog
            urole={user}
            page={currentab}
            addnewoverlay={handleAddOverlay}
          />
        ) : currentab === "contract" ? (
          <Contract />
        ) : currentab === "moredetails" ? (
          <MoreCaseDetails />
        ) : (
          <Performance urole={user} />
        )}
      </div>
    </div>
  );
};

export default Body;
